import styled from '@emotion/styled'

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 498px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`

export const LoadingSpinner = styled.div``

export const LoadingMessage = styled.div`
  padding-bottom: 40px;
  border-radius: 4px;
  margin-top: 40px;
  width: 100%;
  text-align: left;
  align-self: center;
`

export const Message = styled.div`
  text-align: center;
`

export const LoadingButtons = styled.div`
  width: 100%;
`

export const ButtonWrapper = styled.div`
  padding-bottom: 10px;
`
export const Hint = styled.div`
  padding-top: 30px;
  text-align: center;
`
